import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsOfService from "@/pages/legal/TermsOfService";
import SubscriptionTerms from "@/pages/legal/SubscriptionTerms";
import Support from "@/pages/legal/Support";
import Eula from "@/pages/legal/Eula";
import Disclaimer from "@/pages/legal/Disclaimer";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Register />} />
      <Route path="/tour" element={<Landing />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/subscription-terms" element={<SubscriptionTerms />} />
      <Route path="/support" element={<Support />} />
      <Route path="/eula" element={<Eula />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}
